/**
 * Impersonation Bar
 *
 * Fixed 40px orange bar at the top of the viewport when an admin
 * is impersonating another user. Shows who is being impersonated
 * and provides an "End" button to return to the admin session.
 */

import { FiAlertTriangle, FiX } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import { useImpersonationStore } from '../../store'
import { Button } from '../ui/button'
import { Badge } from '../ui/badge'

export function ImpersonationBar() {
  const navigate = useNavigate()
  const isImpersonating = useImpersonationStore((s) => s.isImpersonating)
  const targetUserName = useImpersonationStore((s) => s.targetUserName)
  const targetUserEmail = useImpersonationStore((s) => s.targetUserEmail)
  const targetUserRole = useImpersonationStore((s) => s.targetUserRole)
  const endImpersonation = useImpersonationStore((s) => s.endImpersonation)

  if (!isImpersonating) return null

  return (
    <>
      {/* Spacer to push page content below the fixed bar */}
      <div className="h-10 shrink-0" />

      {/* Fixed bar */}
      <div className="fixed top-0 left-0 right-0 h-10 z-[9999] bg-amber-600 text-white flex items-center px-3 gap-2 text-sm shadow-md">
        <FiAlertTriangle size={14} className="shrink-0" />

        <span className="font-semibold text-[11px] tracking-wide uppercase shrink-0">
          Impersonating
        </span>

        <span className="text-[12px] truncate">
          {targetUserName}
          <span className="text-white/70 ml-1 hidden sm:inline">
            ({targetUserEmail})
          </span>
        </span>

        {targetUserRole && (
          <Badge
            variant="outline"
            size="sm"
            className="border-white/30 text-white text-[10px] shrink-0 hidden md:inline-flex"
          >
            {targetUserRole}
          </Badge>
        )}

        <div className="flex-1" />

        <Button
          variant="ghost"
          size="sm"
          className="h-7 px-3 text-[11px] font-semibold text-white bg-white/20 hover:bg-white/30 hover:text-white"
          onClick={() => endImpersonation(navigate)}
        >
          <FiX size={12} className="mr-1" />
          End Impersonation
        </Button>
      </div>
    </>
  )
}
